import Splide from '@splidejs/splide';

// https://splidejs.com/guides/getting-started/

export default function initiateSplide() {
    const splideElements = document.getElementsByClassName('splide');
    if (splideElements) {
        for (let i = 0; i < splideElements.length; i++) {
            new Splide(splideElements[i], {
                mediaQuery: 'min',
                breakpoints: {
                    320: {
                        perPage: 1,
                    },
                    576: {
                        perPage: 2,
                    },
                    768: {
                        perPage: 3,
                    },
                    1280: {
                        perPage: 4,
                    },
                },
                type: `loop`,
                flickMaxPages: 1,
                updateOnMove: true,
                pagination: true,
                perMove: 1,
            }).mount();
        }
    }
}

window.addEventListener('DOMContentLoaded', initiateSplide);
